import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "./client";
import { useMe } from "./queries/auth";
import type { Role } from "./types";

export interface DevelopmentGateConfig {
  enabled: boolean;
  ends_at: string | null;
  allowed_levels: Role[];
}

export interface DevelopmentGateStatus extends DevelopmentGateConfig {
  allowed: boolean;
}

export function useDevelopmentGate() {
  const me = useMe();
  return useQuery({
    // Never reuse another session's permission while the new one is being checked.
    queryKey: ["development-gate", me.data?.id ?? null, me.data?.role ?? null],
    enabled: !me.isPending,
    queryFn: () => api.get<DevelopmentGateStatus>("/api/development-gate"),
    staleTime: 0,
    refetchOnWindowFocus: true,
  });
}

export function useSaveDevelopmentGate() {
  const client = useQueryClient();
  return useMutation({
    mutationFn: (body: DevelopmentGateConfig) =>
      api.put<DevelopmentGateStatus>("/api/development-gate", body),
    onSuccess: () => client.invalidateQueries({ queryKey: ["development-gate"] }),
  });
}
